import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const Icon = styled.div`
  padding: ${layout.measurements.spacingTiny};
`;
